module.exports = "/_next/static/images/img__card-3-desktop-ba5ed14a1b7ffd1708aa6d6a37e573be.png";